export const getAfterFixUrl = src => {
  if (!src) {
    return
  }

  if (src.indexOf('imageView') !== -1) {
    return src
  }

  const concat = src.indexOf('?') === -1 ? '?' : '|'
  return src + concat + 'imageView2/2/w/300'
}

/**
 * 设置七牛图片裁剪
 * @param {String} src 七牛图片地址
 * @param {String} rate 图片比例 - '宽:高'
 * @param {Number|String} w 需要的图片宽
 */
export const corpImage = (src, rate = '1:1', w = 300) => {
  if (!src || src.indexOf('imageView') !== -1) return src

  const [rw, rh] = rate.split(':')
  const h = Math.round((rh * w) / rw)
  const concat = src.indexOf('?') === -1 ? '?' : '|'
  return src + concat + 'imageView2/1/w/' + w + '/h/' + h
}

/**
 * TODO，这个方法抽到做成公共方法
 */
export const getImageViewLink = (link, width = 100) => {
  if (typeof link !== 'string') return ''

  const imageViewSuffix = `imageView2/2/w/${width}`

  // 有预览参数
  if (link.indexOf('imageView') > -1) {
    return link
  }

  // 有裁剪参数，则拼接裁剪和预览参数
  if (link.indexOf('imageMogr2') > -1) {
    return `${link}|${imageViewSuffix}`
  }

  // 有 ? 且后面有参数，使用 & 拼接预览参数
  if (link.indexOf('?') > -1) {
    return `${link}&${imageViewSuffix}`
  }

  // 没有 ?，使用 ? 拼接预览参数
  if (link.indexOf('?') === -1) {
    return `${link}?${imageViewSuffix}`
  }
}

/**
 * 获取婚宴场地封面图，有 cover_url 取 cover_url
 * 否则取实景图第一张
 */
export const getHallCover = (cover_url, items) => {
  if (cover_url) return getImageViewLink(cover_url)

  return Array.isArray(items) && items[0] && items[0].url
    ? getImageViewLink(items[0].url)
    : ''
}

export const getYears = () => {
  let date = new Date()
  let years = []
  let startYear = 2012
  let endYear = date.getFullYear() + 10
  for (let i = startYear; i <= endYear; i++) {
    years.push(i.toString())
  }
  return years
}
